import React from 'react';
import './AGB.css'; // Import the CSS file

const AGB = () => {
  return (
    <section className="agb-section">
      <title>Allgemeine Geschäftsbedingungen – Nexite IT</title>
      <meta
        name="description"
        content="Allgemeine Geschäftsbedingungen (AGB) der Nexite IT für Webentwicklung, App-Entwicklung und Design-Leistungen."
      />
      <link rel="canonical" href="https://www.nexite-it.com/agb" />

      <div className="agb-container">
        <h1>Allgemeine Geschäftsbedingungen</h1>
        <p className="agb-date">Stand: 13.03.2025</p>

        <div className="agb-content">
          <h2>1. Gültigkeit der AGB</h2>
          <p>
            Die Leistungen der Nexite IT – nachfolgend Agentur genannt – erfolgen ausschließlich aufgrund dieser Geschäftsbedingungen. Diese gelten somit auch für alle künftigen Geschäftsbeziehungen, auch wenn sie nicht nochmals ausdrücklich vereinbart werden.
          </p>

          <h2>2. Leistungen der Agentur</h2>
          <p>
            Zu den Leistungen der Agentur gehören die Beratung und Umsetzung von Maßnahmen hinsichtlich der Konzeption, dem Design und der Entwicklung von Internetseiten sowie Software-Lösungen, Planung und Erstellung von Content, Optimierung von Internetseiten in Suchmaschinen sowie Schaltung und Optimierung von Google-Ads- und Social Media Kampagnen. Der genaue Umfang der Leistungen hängt von dem jeweiligen Angebot ab.
          </p>

          {/* <h2>3. Informationen zur Preisermittlung</h2>
          <p>
            Für Honorarleistungen gilt der individuell vereinbarte Tagessatz. Pauschalpreise werden, sofern nicht anders vereinbart, als Mischkalkulation mit unserem Agentur-Tagessatz von 960€ verrechnet. Das Projektmanagement behält sich vor, nach Anforderung und Kapazität Mitarbeiter:innen mit verschiedenen Erfahrungsleveln einzusetzen. In diesem Fall – oder bei explizitem Wunsch der Auftraggeber nach bestimmten Mitarbeiter:innen – behält sich die Agentur vor, einen vom Level abhängigen Tagessatz zu verrechnen.
          </p>
          <p>
            Nachfolgend finden Sie als Orientierung eine Liste der zugrunde liegenden Tagessätze. Bei Pauschalpreisen besteht keine Verpflichtung zur Dokumentation der erbrachten Stunden. Über die Vereinbarung hinausgehende Stunden werden nur nach Freigabe durch den Auftraggeber in Rechnung gestellt. Nicht erbrachte Stunden werden nicht gutgeschrieben.
          </p>
          <ul>
            <li><strong>Junior:</strong> 880 €</li>
            <li><strong>Professional:</strong> 960 €</li>
            <li><strong>Specialist:</strong> 1.040 €</li>
            <li><strong>Senior / Teamlead:</strong> 1.200 €</li>
            <li><strong>Geschäftsführung:</strong> 1.600 €</li>
          </ul> */}

          <h2>3. Vergütung und Zahlung</h2>
          <h3>a) Abrechnung</h3>
          <p>
            Die Abrechnung der Leistungen wird in den jeweiligen Angeboten explizit geregelt. Sollte jedoch nichts anderes vereinbart werden, erfolgt die Abrechnung rückwirkend monatlich auf Basis der geleisteten Aufwände. Für die erbrachte Leistung bedarf es keiner Abnahme im Sinne des §§ 640 ff. BGB.
          </p>
          <h3>b) Zahlungsbedingungen</h3>
          <p>
            Rechnungen verstehen sich ohne zzgl. gesetzlicher Mehrwertsteuer und sind – sofern nichts anderes schriftlich vereinbart – zahlbar 10 Tage nach Rechnungsstellung.
          </p>
          <h3>c) Zwischenrechnung</h3>
          <p>
            Die Agentur behält sich vor, bei fehlender Nichtwirkung und daraus resultierender Pausierung der Zusammenarbeit eine Zwischenrechnung über alle bis dahin angefallenen Aufwände, mindestens aber 50% des Projektvolumens, zu stellen.
          </p>

          <h2>4. Mitwirkungspflichten des Auftraggebers</h2>
          <p>
            Der Auftraggeber verpflichtet sich, die Agentur aktiv und bestmöglich bei der Leistungserbringung zu unterstützen. Insbesondere, indem er ihr rechtzeitig und kostenfrei die nach Auffassung der Agentur zur Vertragsdurchführung notwendigen Informationen, Unterlagen und Materialien einschließlich Zugangsdaten sowie die angeforderten Inhalte und Inhaltselemente in der zur unmittelbaren Verwertung geeigneten Form zur Verfügung stellt.
          </p>

          <h2>5. Lieferbedingungen und Verzug</h2>
          <p>
            Angegebene Liefer-/Leistungstermine sind nur dann verbindlich, wenn diese ausdrücklich und schriftlich vereinbart wurden. Ist die Nichteinhaltung von solchen verbindlichen Vertragsfristen auf höhere Gewalt oder auf ähnliche, von der Agentur nicht zu vertretende Umstände zurückzuführen, verlängern sich die Fristen angemessen.
          </p>

          <h2>6. Datenschutz</h2>
          <p>
            Die Parteien werden die jeweils anwendbaren, insbesondere die in Deutschland gültigen, datenschutzrechtlichen Bestimmungen (insb. DSGVO) beachten. Genauere Angaben zum Datenschutz sind der Datenschutzerklärung und den technischen und organisatorischen Maßnahmen (TOM) der Agentur zu entnehmen.
          </p>

          <h2>7. Geheimhaltung und Veröffentlichung</h2>
          <p>
            Die Vertragspartner werden über alle vertraulich zu behandelnden Informationen, die ihnen im Rahmen dieses Vertragsverhältnisses zur Kenntnis gelangt sind, Stillschweigen bewahren bzw. diese nur im vorher schriftlich hergestellten Einvernehmen der jeweils anderen Partei Dritten gegenüber verwenden.
          </p>

          <h2>8. Haftungsbeschränkung</h2>
          <p>
            Die Agentur haftet ausschließlich für Vorsatz und grobe Fahrlässigkeit. Für leichte Fahrlässigkeit haftet Nexite IT (Inhaber: Khashayar Alavi) nur bei Verletzung einer wesentlichen Vertragspflicht sowie bei Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit eines Menschen.
          </p>

          <h2>9. Einsatz von Dritten/Subunternehmen</h2>
          <p>
            Der Agentur ist es gestattet, – ohne Einwilligung des Auftraggebers – zur Erbringung der vertraglich vereinbarten Leistungen Dritte bzw. Subunternehmen einzusetzen. Die Agentur trägt dafür Sorge, dass die von ihr für die Leistungserbringung eingesetzten Personen ausreichend qualifiziert sind.
          </p>

          <h2>10. Eigentumsvorbehalt, Rechte am geistigen Eigentum</h2>
          <p>
            Bis zur vollständigen Bezahlung aller Verbindlichkeiten aus der Geschäftsbeziehung bleiben die von der Agentur erbrachten Leistungen Eigentum der Agentur. Das Urheberrecht aller Leistungen bleibt auf unbestimmte Zeit bei der Agentur.
          </p>

          <h2>11. Abwerbeverbot</h2>
          <p>
            Jede Partei verpflichtet sich, während – sowie ein Jahr nach Beendigung – dieses Vertrags keine Mitarbeitenden der anderen Partei direkt oder indirekt abzuwerben. Für jeden Fall der Zuwiderhandlung gegen die Bestimmung zahlt die verstoßende Partei an die andere Partei eine Vertragsstrafe in Höhe von zwei Bruttojahresgehältern des betreffenden Mitarbeitenden.
          </p>

          <h2>12. Gerichtsstand</h2>
          <p>
            Soweit der Auftraggeber Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist, ist Köln ausschließlicher Gerichtsstand für alle sich aus dem Vertragsverhältnis unmittelbar oder mittelbar ergebenden Streitigkeiten.
          </p>

          <h2>13. AGB-Änderungen</h2>
          <p>
            Änderungen und Ergänzungen dieser Vereinbarung bedürfen der Schriftform. Dies gilt auch für ein Abweichen von der Schriftformklausel. Mündliche Nebenabreden bestehen nicht.
          </p>

          <h2>14. Salvatorische Klausel</h2>
          <p>
            Sollte eine der Bestimmungen dieser AGB nichtig sein oder werden, so bleibt der Vertrag im Übrigen wirksam. Die Vertragspartner werden die nichtige Bestimmung durch eine solche ersetzen, die dem Willen der Vertragspartner wirtschaftlich am nächsten kommt. Gleiches gilt für eventuelle Regelungslücken.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AGB;